import React, { useContext, useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { KTSVG } from '../../helpers'
import RolePermissionContext from '../../context/RolePermissionContext'

const ListColumns = () => {
  const location = useLocation()
  const { data2 } = useContext(RolePermissionContext)

  const [processAutomationItems, setProcessAutomationItems] = useState<any[]>([])

  useEffect(() => {
    if (data2 && data2.getModuleAcessByRole && data2.getModuleAcessByRole.data) {
      const filteredItems = data2.getModuleAcessByRole.data.filter(
        (item: any) =>
          item.isAccess &&
          [
            'Form-Builder',
            'Resume-Parser',
            'IBot-Assistant',
            'Document-Managament-System',
            'Bussiness-Process-Automation',
            'Optical-Character-Recongnition'
          ].includes(item.module.name)
      )
      setProcessAutomationItems(filteredItems)
    }
  }, [data2])
  console.log(processAutomationItems)
  // testing

  return (
    <>
      <div className='card-body px-4'>
        <div className='menu-item'>
          <div className='menu-content pb-3'>
            <span className='menu-section fw-bolder text-uppercase fs-4 ls-1'>
              Process Automation
            </span>
          </div>
        </div>
        {processAutomationItems.map((item: any, index: number) => {
          const sideMenu = item.module.sideMenu

          return (
            <div className='menu-item' key={index}>
              <div
                className={`menu-link without-sub ${
                  location.pathname.includes(sideMenu?.to) ? 'text-primary' : ''
                }`}
              >
                <Link to={sideMenu?.to} className='d-flex'>
                  <span className='menu-icon'>
                    <KTSVG path={sideMenu?.icon} className='svg-icon-2 fs-3' />
                  </span>
                  <span
                    className={`menu-title fs-4 fw-bold  text-hover-primary ${
                      location.pathname.includes(sideMenu?.to) ? 'text-primary' : 'text-muted'
                    }`}
                  >
                    {sideMenu?.title === 'Resume Parser' ? 'Document Parser' : sideMenu?.title}
                  </span>
                </Link>
              </div>
            </div>
          )
        })}

        <div className='menu-item'>
          <div
            className={`menu-link without-sub ${
              location.pathname.includes('workflow-automation') ? 'text-primary' : ''
            }`}
          >
            <Link to='workflow-automation' className='d-flex'>
              <span className='menu-icon'>
                <KTSVG path='/media/icons/duotune/coding/cod002.svg' className='svg-icon-2 fs-3' />
              </span>
              <span
                className={`menu-title fs-4 fw-bold  text-hover-primary ${
                  location.pathname.includes('workflow-automation') ? 'text-primary' : 'text-muted'
                }`}
              >
                Workflow Automation
              </span>
            </Link>
          </div>
        </div>
      </div>
    </>
  )
}

export default ListColumns
